import { render, staticRenderFns } from "./roleCreateLog.vue?vue&type=template&id=3498389e&"
import script from "./roleCreateLog.vue?vue&type=script&lang=js&"
export * from "./roleCreateLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3498389e')) {
      api.createRecord('3498389e', component.options)
    } else {
      api.reload('3498389e', component.options)
    }
    module.hot.accept("./roleCreateLog.vue?vue&type=template&id=3498389e&", function () {
      api.rerender('3498389e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/roleCreateLog.vue"
export default component.exports